import { ISchemaExplorerType } from "@/api/schema";
import { IApiState } from "../api";
import { nonConfigurableFields, readonlyKeys } from "./constants";
import { ApiSchemaInitializer } from "./initializer";
import { ITypeConfig } from "./types";

export class ApiSchema {
  public types: Record<string, ITypeConfig> = {};

  public idKey = "id";
  public autoGeneratedKeys = ["id", "createdAt", "updatedAt"];
  public blacklistedKeys = ["__typename", "selected"];
  public readonlyKeys = readonlyKeys;
  public nonConfigurableFields = nonConfigurableFields;

  constructor(
    public apiDeclaration?: Pick<IApiState, "types" | "enums">,
    public graphqlSchemaFieldTypes?: Record<string, ISchemaExplorerType>,
  ) {
    this.initialize();
  }

  private initialize() {
    const initializer = new ApiSchemaInitializer();
    const apiDeclarationTypes = this.apiDeclaration?.types ?? [];
    const apiDeclarationEnums = this.apiDeclaration?.enums ?? [];

    if (apiDeclarationTypes.length > 0) {
      this.types = initializer.initializeTypesFromApiDeclaration(
        apiDeclarationTypes,
        apiDeclarationEnums,
      );
    } else {
      this.types = initializer.initializeTypesFromGraphqlSchema(
        this.graphqlSchemaFieldTypes,
      );
    }
  }
}
